<div class="klab-login-card">
  <div class="klab-login-card__header">
    <div class="klab-login-card__date">
      <span class="klab-login-card__date-text">
        {{ currentDayAbbr() }}<br />{{ currentDayNumber() }}
      </span>
    </div>
    <div class="klab-login-card__logo">Klab<span>*</span></div>
  </div>

  <div class="klab-login-card__title">
    <h2>
      <span class="klab-login-card__hello">¡Bienvenido,</span
      ><span class="klab-login-card__username"> {{ welcomeMessage() }}</span
      ><span class="klab-login-card__hello">!</span>
    </h2>
  </div>

  <ng-container *ngIf="alert">
    <div
      *ngIf="alert.icon === 'intentos'"
      class="klab-login-card__alert-intentos"
    >
      <div class="klab-login-card__alert-intentos-icon">
        <img src="assets/core-ui/icons/icon_close-red.svg" alt="Cerrar" />
      </div>
      <div class="klab-login-card__alert-intentos-content">
        <div class="klab-login-card__alert-intentos-title">
          {{ alert.title }}
        </div>
        <div class="klab-login-card__alert-intentos-text">
          {{ alert.message }}
        </div>
      </div>
    </div>
    <core-ui-alert
      *ngIf="alert.icon !== 'intentos'"
      [variant]="alert.variant"
      [icon]="alert.icon"
      [title]="alert.title"
      [message]="alert.message"
    >
    </core-ui-alert>
  </ng-container>

  <form
    [formGroup]="form"
    (ngSubmit)="onLogin()"
    class="klab-login-card__form-wrapper"
  >
    <div class="klab-login-card__form">
      <core-ui-input-text
        label="Correo"
        placeholder="Ingresa tu correo electrónico"
        formControlName="username"
        variant="login"
        [clearable]="true"
        [errorMessage]="usernameError"
      >
      </core-ui-input-text>

      <core-ui-input-text
        label="Contraseña"
        type="password"
        placeholder="Ingresa tu contraseña"
        formControlName="password"
        iconRight="Eye_off"
        variant="login"
        [errorMessage]="passwordError"
      >
      </core-ui-input-text>
    </div>

    <div class="klab-login-card__recovery">
      <span>¿Olvidaste tu contraseña?</span>
      <button
        type="button"
        class="klab-login-card__recovery-link"
        (click)="navigateToRecoverPassword()"
      >
        Click Aquí
      </button>
    </div>

    <div class="klab-login-card__actions">
      <core-ui-button-base
        variant="primary"
        size="lg"
        [block]="true"
        type="submit"
        [loading]="loading"
      >
        Ingresar
      </core-ui-button-base>
    </div>
  </form>
</div>
